import React from 'react';
import { Link } from 'react-router-dom';

import { FiChevronRight } from 'react-icons/fi';

import { Container } from './styles';

interface ICardModuleProps {
  id: string;
  background?: string;
  title: string;
  description: string;
  link: string;
  linkTitle?: string;
  icon?: string;
  checked?: boolean;
  bgColor?: string;
}

const CardModule: React.FC<ICardModuleProps> = ({ background, title, linkTitle, description, link, icon, checked, bgColor }) => {

  return (
    <>
      <Container background={background} to={link} bgColor={bgColor}>
        <header>
          <div>
            <h2>{title}</h2>
          </div>
          <p>{description}</p>
        </header>
        <footer>
          <Link to={link}>{linkTitle || 'Acessar Plano de estudos'} <FiChevronRight /></Link>
        </footer>
      </Container>
    </>
  );
}

export default CardModule;